import { CaretRightIcon, MapPinIcon } from '@phosphor-icons/react';
import { useState } from 'react';
import RequestLoadModal from '../home/modals/RequestLoadModal';

// Load Board V1 — Web. The "Find Me Freight" entry on My Resources, a second
// entry point beside the CustomerHome card (RequestLoadEntry). Both open the
// same RequestLoadModal.
//
// Wears the same full-width row shape as RentalRequestCard above it and, like
// it, is a STATIC client-side card rather than an item from the resources
// config. No pre-active gate here: ResourcesPage redirects anyone who isn't
// active before this mounts.

const FindMeFreightCard = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        data-testid="resources:findMeFreight"
        onClick={() => setIsOpen(true)}
        className="flex w-full items-center gap-4 rounded-xl border border-bordergray bg-white p-4 text-left transition-shadow hover:shadow-md"
      >
        <div className="flex h-[56px] w-[56px] shrink-0 items-center justify-center rounded-lg bg-primarybg">
          <MapPinIcon size={28} weight="regular" className="text-primary" />
        </div>
        <div className="flex flex-1 flex-col gap-1">
          <h3 className="text-base font-semibold text-gray-900">
            Find Me Freight
          </h3>
          <p className="text-sm text-gray-600">
            We&apos;ll find and book loads for you.
          </p>
        </div>
        <CaretRightIcon size={18} className="shrink-0 text-gray-400" />
      </button>

      {/* Mounted only while open, so each open is a fresh form — same reason
          as RequestLoadEntry: a late geolocation fix or POST resolve must not
          write into the next open. */}
      {isOpen && (
        <RequestLoadModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
      )}
    </>
  );
};

export default FindMeFreightCard;
